package horcrux.frontend.common.views.collections.collectiondialogs

import horcrux.common.api.dtos.types.CollectionMetadata
import horcrux.frontend.common.GlobalAppState
import horcrux.frontend.common.views.collections.CollectionNavigatorMenuOption
import mui.material.AlertColor
import react.FC
import react.Props

external interface DeleteCollectionDialogProps : Props {
    var currentCollectionMetadata: CollectionMetadata
    var globalAppState: GlobalAppState
}

val DeleteCollectionDialog = FC<DeleteCollectionDialogProps> { props ->
    val currentCollectionMetadataMaybeState = props.globalAppState.currentCollectionMetadataMaybeState
    DeleteCollectionMetadataDialog {
        this.globalAppState = props.globalAppState
        this.title = CollectionNavigatorMenuOption.DELETE.viewName
        this.text =
            "Are you sure you want to delete collection ${props.currentCollectionMetadata.collectionName.betterToString()}?"
        this.showDialogState = props.globalAppState.collectionNavigatorState.showDeleteCollectionDialogState
        this.onClickDelete = {
            props.globalAppState.submitBackendAPIRequestAsync { backendClient ->
                backendClient.deleteCollection(props.currentCollectionMetadata.id).map {
                    currentCollectionMetadataMaybeState.reset()
                    props
                        .globalAppState
                        .collectionMetadataByIDState
                        .update { collectionMetadataByID -> collectionMetadataByID.remove(props.currentCollectionMetadata) }
                    props.globalAppState.updateBanner(AlertColor.info, "Collection deleted")
                }.bind()
            }
        }
    }
}
